import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Input,
  FormGroup,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import styles from "../styles";
import { InputLengthHelperText } from '../../Common/FormModal';
import { LPLItemDTO, LocationDTO } from "@beable/roster-backend-client-v1";

interface LoginPicklistItemFormProps {
  locations: LocationDTO[];
  submitForm: (
    name: string,
    purl: string,
    stateName: string,
    id?: string
  ) => void;
  onClose: () => void;
  selectedItem?: LPLItemDTO;
}

export default function LoginPicklistItemForm({
  locations,
  submitForm,
  onClose,
  selectedItem,
}: LoginPicklistItemFormProps) {
  const theme = useTheme();
  const modalStyles = styles.addModalStyles(theme);

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [purl, setPurl] = useState("");
  const [stateName, setStateName] = useState(locations[0].name || "");

  const handleSubmit = () => {
    submitForm(name, purl, stateName, id);
  };

  const resetState = () => {
    setName("");
    setPurl("");
    setStateName(locations[0].name || "");
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  useEffect(() => {
    const initialForm = () => {
      setId(selectedItem!.id);
      setName(selectedItem!.name);
      setPurl(selectedItem!.siteName);
      setStateName(selectedItem!.state);
    };

    if (selectedItem) {
      initialForm();
    }
  }, [selectedItem]);

  return (
    <>
      <FormGroup>
        <FormControl variant="standard">
          <InputLabel htmlFor="siteName">Name*</InputLabel>
          <Input
            onChange={(e: any) => setName(e.target.value)}
            value={name}
            id="siteName"
            aria-describedby="site name"
          />
          <InputLengthHelperText str={name} />
        </FormControl>
        <FormControl variant="standard">
          <InputLabel htmlFor="purlName">{`Site Name${selectedItem ? '*' : ''}`}</InputLabel>
          <Input
            onChange={(e: any) => setPurl(e.target.value)}
            value={purl}
            id="purlName"
            aria-describedby="purlName"
          />
          <InputLengthHelperText str={purl} />
        </FormControl>

        <FormControl variant="standard">
          <InputLabel id="locationPickerLabel" htmlFor="locationPicker">
            Location Picker
          </InputLabel>
          <Select
            labelId="locationPickerLabel"
            id="locationPicker"
            value={stateName ?? ''}
            onChange={(e: any) => setStateName(e.target.value)}
          >
            {locations.map((st) => (
              <MenuItem value={st.name} key={st.id}>
                {st.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FormGroup>
      <FormGroup sx={[modalStyles.mt2, modalStyles.dfr]}>
        <Button
          variant="contained"
          color="primary"
          disabled={!name || (selectedItem && !purl)}
          onClick={handleSubmit}
        >
          {selectedItem ? 'Edit' : 'Add site'}
        </Button>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={modalStyles.ml2}
        >
          Close
        </Button>
      </FormGroup>
    </>
  );
}